document.addEventListener( 'wpcf7mailsent', function( event ) {
    //console.log(event);
    if(event.detail.contactFormId == 1966){
        window.dataLayer.push({
            "event" : "cf7submission",
            "formId" : event.detail.contactFormId,
            "response" : event.detail.inputs
        });
    }
});